import * as Yup from 'yup'
export function updatevalidations(values) {
    return Yup.object().shape({

      reps_id: Yup.string().required('This field is required'),
      username: Yup.string().required('This field is required').min(5, 'Username should be 5 chars minimum.'),
      account_type: Yup.string().required('This field is required'),

      //individual
      first_name: Yup.string().required('This field is required'),
      last_name: Yup.string().required('This field is required'),
      date_birth_options: Yup.string().required('This field is required'),
      date_birth: Yup.string().notRequired().when('date_birth_options', {
        is: (val) => val === '1',
        then: Yup.string().required('This field is required'),
        otherwise: Yup.string().notRequired()
      }),
      date_birth_text: Yup.string().notRequired().when('date_birth_options', {
        is: (val) => val === '2',
        then: Yup.string().required('This field is required'),
        otherwise: Yup.string().notRequired()
      }),
      citizenship: Yup.string().required('This field is required'),
      citizen_country: Yup.string().notRequired().when('citizenship', {
        is: (val) => val === '2',
        then: Yup.string().required('This field is required'),
        otherwise: Yup.string().notRequired()
      }),
      type_id: Yup.string().required('This field is required'),
      //id_number: Yup.string().required('This field is required'),
      address1: Yup.string().required('This field is required'),
      city: Yup.string().required('This field is required'),
      state: Yup.string().required('This field is required'),
      country: Yup.string().required('This field is required'),
      postal_code: Yup.string().required('This field is required'),
      primary_number: Yup.string().required('This field is required'),
      email: Yup.string().email('Please enter a valid email').required('This field is required'),
      marital_status: Yup.string().required('This field is required'),
      //no_dependents: Yup.string().required('This field is required'),

      //joint
      joint_first_name: Yup.string().notRequired().when('account_type', {
        is: (val) => val >1,
        then: Yup.string().required('This field is required'),
        otherwise: Yup.string().notRequired()
      }),
      joint_last_name: Yup.string().notRequired().when('account_type', {
        is: (val) => val >1,
        then: Yup.string().required('This field is required'),
        otherwise: Yup.string().notRequired()
      }),
      joint_date_birth_options: Yup.string().notRequired().when('account_type', {
        is: (val) => val >1,
        then: Yup.string().required('This field is required'),
        otherwise: Yup.string().notRequired()
      }),


      joint_date_birth: Yup.string().notRequired().when('account_type', {
        is: (val) => val >1,
        then: Yup.string().notRequired().when('joint_date_birth_options', {
          is: (val) => val === '1',
          then: Yup.string().required('This field is required'),
          otherwise: Yup.string().notRequired()
        }),
        otherwise: Yup.string().notRequired()
      }),

      joint_date_birth_text: Yup.string().notRequired().when('account_type', {
        is: (val) => val >1,
        then: Yup.string().notRequired().when('joint_date_birth_options', {
          is: (val) => val === '2',
          then: Yup.string().required('This field is required'),
          otherwise: Yup.string().notRequired()
        }),
        otherwise: Yup.string().notRequired()
      }),

      joint_citizenship: Yup.string().notRequired().when('account_type', {
        is: (val) => val >1,
        then: Yup.string().required('This field is required'),
        otherwise: Yup.string().notRequired()
      }),
      joint_citizen_country: Yup.string().notRequired().when('account_type', {
        is: (val) => val >1,
        then: Yup.string().notRequired().when('joint_citizenship', {
          is: (val) => val === '2',
          then: Yup.string().required('This field is required'),
          otherwise: Yup.string().notRequired()
        }),
        otherwise: Yup.string().notRequired()
      }),

      joint_type_id: Yup.string().notRequired().when('account_type', {
        is: (val) => val >1,
        then: Yup.string().required('This field is required'),
        otherwise: Yup.string().notRequired()
      }),
      /*joint_id_number: Yup.string().notRequired().when('account_type', {
        is: (val) => val >1,
        then: Yup.string().required('This field is required'),
        otherwise: Yup.string().notRequired()
      }),*/
      joint_address1: Yup.string().notRequired().when('account_type', {
        is: (val) => val >1,
        then: Yup.string().required('This field is required'),
        otherwise: Yup.string().notRequired()
      }),
      joint_city: Yup.string().notRequired().when('account_type', {
        is: (val) => val >1,
        then: Yup.string().required('This field is required'),
        otherwise: Yup.string().notRequired()
      }),
      joint_state: Yup.string().notRequired().when('account_type', {
        is: (val) => val >1,
        then: Yup.string().required('This field is required'),
        otherwise: Yup.string().notRequired()
      }),
      joint_country: Yup.string().notRequired().when('account_type', {
        is: (val) => val >1,
        then: Yup.string().required('This field is required'),
        otherwise: Yup.string().notRequired()
      }),
      joint_postal_code: Yup.string().notRequired().when('account_type', {
        is: (val) => val >1,
        then: Yup.string().required('This field is required'),
        otherwise: Yup.string().notRequired()
      }),
      joint_primary_number: Yup.string().notRequired().when('account_type', {
        is: (val) => val >1,
        then: Yup.string().required('This field is required'),
        otherwise: Yup.string().notRequired()
      }),
      joint_email: Yup.string().notRequired().when('account_type', {
        is: (val) => val >1,
        then: Yup.string().email('Please enter a valid email').required('This field is required'),
        otherwise: Yup.string().notRequired()
      }),
      joint_marital_status: Yup.string().notRequired().when('account_type', {
        is: (val) => val >1,
        then: Yup.string().required('This field is required'),
        otherwise: Yup.string().notRequired()
      }),
      /*joint_no_dependents: Yup.string().notRequired().when('account_type', {
        is: (val) => val >1,
        then: Yup.string().required('This field is required'),
        otherwise: Yup.string().notRequired()
      }),*/



      //finance
      years_stock: Yup.string().required('This field is required'),
      years_options: Yup.string().required('This field is required'),
      years_mutual: Yup.string().required('This field is required'),
      years_futures: Yup.string().required('This field is required'),
      years_forex: Yup.string().required('This field is required'),
      finance_annual: Yup.string().required('This field is required'),
      finance_marginal: Yup.string().required('This field is required'),
      finance_totalnet: Yup.string().required('This field is required'),
      finance_liquidnet: Yup.string().required('This field is required'),
      finance_sourceincome: Yup.string().required('This field is required'),
      number_contracts: Yup.string().required('This field is required'),
      name_contracts: Yup.string().required('This field is required'),
      finance_amount: Yup.string().required('This field is required'),
      finance_fund: Yup.string().required('This field is required'),

      /*specify_finance_annual: Yup.string().notRequired().when('finance_annual', {
        is: (val) => val == '1',
        then: Yup.string().required('This field is required'),
        otherwise: Yup.string().notRequired()
      }),*/

      /*specify_finance_totalnet: Yup.string().notRequired().when('finance_totalnet', {
        is: (val) => val == '1',
        then: Yup.string().required('This field is required'),
        otherwise: Yup.string().notRequired()
      }),
      specify_finance_liquidnet: Yup.string().notRequired().when('finance_liquidnet', {
        is: (val) => val == '1',
        then: Yup.string().required('This field is required'),
        otherwise: Yup.string().notRequired()
      }),*/


    });
}
